import Vue from 'vue'

const GlobalEventBus = new Vue();
export default GlobalEventBus;
